export default "__VITE_ASSET__DV9tDKO7__"